import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import DateFnsUtils from '@date-io/date-fns';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { es } from 'date-fns/locale';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography } from '@mui/material';
import moment from 'moment';
import {
	actionProcess,
	addBias,
	getContactListFinalProcessForm,
	setBiases,
	updateSubBiases,
} from '../../../actions/biases';
import { HeaderSection } from './BiasInfo';
import { useState } from 'react';
import {
	getFullName,
	handleError,
	handleSuccess,
} from '../../../helpers/utils';
import { ProcessAction } from './ProcessAction';
import { LoadingButton } from '@mui/lab';
import { getOrderInfo } from '../../../actions/orders';
import {
	sendWhatsApp,
	template2,
	template4,
	template6,
} from '../../../helpers/whatsappApi';
import { formatDateMX } from '../../../helpers/hours';

export const ProcessForm = ({
	currentBias = null,
	// subbiasId = null,
	setIsProcessForm = null,
	areas = [],
	// refresh = null,
	// refreshSubbias = null,
	refreshBias = null,
	// setCurrentSubbias = null,
	selectedProcess = null,
	setSelectedProcess = null,
}) => {
	// Date
	const [date, setDate] = useState(null);

	// loading
	const [isLoading, setIsLoading] = useState(false);

	// Action option (start or final date)
	const [actionOption, setActionOption] = useState(null);

	// Different area
	const [differentArea, setDifferentArea] = useState(null);

	// User
	const { user } = useSelector((state) => state);

	// Dispatch
	const dispatch = useDispatch();

	// Current bias and subbiases
	const {
		biases: subbiasesStore = [],
		// currentBias,
		updateSubbiasesFlag,
	} = useSelector((state) => state.biases);

	// Individual areas store
	const { individualAreas = [] } = useSelector((state) => state);

	// Get current area from user
	const handleGetUserArea = () => {
		const finalArea = differentArea || user.area.name;
		const area =
			individualAreas.find((area) => area.name === finalArea) || null;
		return area ? { ...area, authorized_days: area.days } : null;
	};

	const getNecessaryDataForCalculus = () => {
		// Area
		const userArea = handleGetUserArea();
		// Date
		const formattedDate = moment(date).format('YYYY-MM-DD') || null;
		// Bias id
		const biasId = currentBias?.id || null;
		// Order id
		const orderId = currentBias?.order?.id || null;
		if (!formattedDate) {
			handleError(null, 'Ocurrió un error con la fecha.');
			return false;
		}
		if (!userArea) {
			handleError(
				null,
				'Ocurrió un error al intentar checar las subpartidas.'
			);
			return false;
		}
		if (!biasId && !orderId) {
			handleError(
				null,
				'Ocurrió un error al intentar obtener el ID de la partida y la orden.'
			);
			return false;
		}
		return {
			userArea,
			formattedDate,
			biasId,
			biasKey: currentBias?.key || '-',
			orderId,
		};
	};

	// Handle send whatsapp order is done
	const handleSendWhatsappOrderIsDone = async (order, user) => {
		// Send WhatsApp to report the order has been completed
		await sendWhatsApp(
			order,
			user,
			order?.contacts,
			template4(phonesList, order?.number_order)
		);
	};

	// Handle send whatsapp alert if the user is setting the final date
	const handleSendWhatsappFinalDate = async (
		order,
		user,
		biasKey,
		biasId
	) => {
		getContactListFinalProcessForm(biasId).then(async ({ data }) => {
			if (data?.ok) {
				if (data?.phone_numbers) {
					// Send WhatsApp to report the order has been completed
					await sendWhatsApp(
						order,
						user,
						data.phone_numbers,
						template6(
							order.number_order,
							user.area.name,
							biasKey,
							getFullName(user)
						),
						false
					);
				}
			}
		});
	};

	// Handle send whatsapp id there's any delay
	const handleSendWhatsappDelay = async (
		subbiasItem,
		new_date_order,
		order,
		numBiases = 0,
		user
	) => {
		// Message
		const msg = `${order.number_order} (${numBiases} partidas)`;
		const date = formatDateMX(new_date_order);
		if (date && date !== '-') {
			// Send WhatsApp to report the order has been completed
			await sendWhatsApp(
				order,
				user,
				order?.contacts,
				template2(msg, subbiasItem.delayed_days, subbiasItem.area, date)
			);
		}
	};

	// Handle cancel process
	const handleCancelProcessForm = () => {
		// Remove all selected subbiases
		dispatch(setBiases([]));
		// Cancel form
		setIsProcessForm(false);
		setSelectedProcess(null);
	};

	// Handle save
	const handleSave = () => {
		const data = getNecessaryDataForCalculus();
		if (data) {
			// Destructure data
			const {
				userArea,
				formattedDate,
				biasId,
				orderId,
				biasKey = '-',
			} = data;
			// Start loading
			setIsLoading(true);
			// Calculate process and dates
			actionProcess({
				action_option: actionOption,
				subbiases_ids: subbiasesStore,
				area: userArea,
				date: formattedDate,
				user: user.id,
				bias: biasId,
				order: orderId,
			})
				.then(async ({ data: actionProcessResponse }) => {
					if (actionProcessResponse.ok) {
						let order = null;
						// Refresh subbiases
						dispatch(updateSubBiases(!updateSubbiasesFlag));
						// Refesh subbias
						refreshBias(biasId);
						// Deselect subbiases
						dispatch(addBias([]));

						if (
							actionProcessResponse.is_order_done ||
							actionProcessResponse.delayed_subbiases.length > 0
						) {
							// Get order info
							order = (await getOrderInfo(orderId)).data;
						}

						// Send whatsapp if order is done
						if (actionProcessResponse.is_order_done) {
							handleSendWhatsappOrderIsDone(order, user);
						}
						// Send whatsapp if user is setting final date
						if (actionOption === 'final_date') {
							handleSendWhatsappFinalDate(
								order,
								user,
								biasKey,
								biasId
							);
						}
						// Send whatsapp if there's any delays
						if (
							actionProcessResponse.delayed_subbiases.length > 0
						) {
							handleSendWhatsappDelay(
								actionProcessResponse.delayed_subbiases[0],
								actionProcessResponse.new_date_order,
								order,
								actionProcessResponse.delayed_subbiases.length,
								user
							);
						}
						// Fedback success
						handleSuccess('¡Cálculos realizados con éxito!');
					} else {
						// Fedback error
						handleError(null, actionProcessResponse.error);
					}

					// Quit process form
					handleCancelProcessForm();
				})
				.catch((error) => {
					handleError(
						error,
						'Ocurrió un error al intentar calcular progresos y fechas.'
					);
				})
				.finally(() => {
					setIsLoading(false);
				});
		}
	};

	// Text field component
	const TextFieldComponent = (params, label) => (
		<TextField fullWidth margin='normal' {...params} label={label} />
	);

	// Show form condition
	const showForm = () => subbiasesStore.length > 0 && user;

	// Which label to use
	const whichLabelDate = () => {
		if (actionOption === 'entry_date') {
			return 'Fecha de asignación';
		} else if (actionOption === 'final_date') {
			return 'Fecha de entrega';
		} else {
			return '';
		}
	};

	const handleAreaName = (areaName) => {
		// Return the area's name
		if (areaName === 'Almacén y Requerimientos') {
			return 'Almacén y Requerimientos (Avíos y Comercios | Tela)';
		} else {
			return areaName || 'Administrativa';
		}
	};

	return (
		<LocalizationProvider
			dateAdapter={AdapterDateFns}
			adapterLocale={es}
			utils={DateFnsUtils}
		>
			{showForm() && (
				<>
					{actionOption === null ? (
						<ProcessAction
							currentBias={currentBias}
							action={{
								option: actionOption,
								handle: setActionOption,
								cancelAll: handleCancelProcessForm,
							}}
							setDifferentArea={setDifferentArea}
						/>
					) : (
						<div style={{ padding: '25px' }}>
							{/* HEADER */}
							<HeaderSection
								text={
									selectedProcess
										? 'Completar proceso'
										: 'Nuevo progreso'
								}
							/>

							<br />
							{/* SUBHEADER */}
							<Typography variant='p' gutterBottom>
								{selectedProcess
									? 'Completar proceso'
									: 'Nuevo proceso'}{' '}
								del área "{handleAreaName(user?.area?.name)}
								".
								<br />
								{areas && (
									<>
										{subbiasesStore.length > 0 ? (
											<u>
												Se tienen{' '}
												{individualAreas?.find(
													(item) =>
														item.name ===
														user?.area?.name
												)?.days || 'X'}{' '}
												día(s) permitidos.
											</u>
										) : (
											<u>
												Se tienen{' '}
												{areas?.find(
													(item) =>
														item.name ===
														user?.area?.name
												)?.authorized_days || 'X'}{' '}
												día(s) permitidos.
											</u>
										)}
									</>
								)}
							</Typography>

							<hr />

							<Grid container spacing={1}>
								<Grid
									item
									xs={12}
									style={{ margin: '-16px 0 0 0' }}
								>
									<DesktopDatePicker
										fullWidth
										label={whichLabelDate()}
										inputFormat='dd/MM/yyyy'
										// Cambiar a false
										disablePast={false}
										value={date}
										onChange={(value) => {
											setDate(value);
										}}
										renderInput={(params) =>
											TextFieldComponent(
												params,
												whichLabelDate()
											)
										}
									/>
								</Grid>

								<Grid item xs={6}>
									<Button
										fullWidth
										variant='contained'
										color='error'
										onClick={handleCancelProcessForm}
									>
										Cancelar
									</Button>
								</Grid>
								<Grid item xs={6}>
									<LoadingButton
										fullWidth
										color={
											actionOption === 'entry_date'
												? 'primary'
												: 'success'
										}
										variant='contained'
										onClick={handleSave}
										loading={isLoading}
									>
										{actionOption === 'entry_date'
											? 'Guardar'
											: 'Completar'}
									</LoadingButton>
								</Grid>
							</Grid>
						</div>
					)}
				</>
			)}
		</LocalizationProvider>
	);
};
